import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
	signal,
	WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ILabel } from '@app/pages/settings/interfaces/labels.interfaces';
import { LabelBadgeComponent } from '@app/pages/settings/labels/label-item-row/label-badge/label-badge.component';

@Component({
	selector: 'au-cmms-label-column[labels]',
	imports: [CommonModule, LabelBadgeComponent],
	templateUrl: './au-cmms-label-column.component.html',
	styleUrls: ['./au-cmms-label-column.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuCmmsLabelColumnComponent {
	@Input() set labels(value: ILabel[]) {
		this.selectedLabels.set(value);
	}

	@Output() viewMoreClicked = new EventEmitter<void>();

	readonly maxLength = 2;

	selectedLabels: WritableSignal<ILabel[]> = signal([]);

	openEntity() {
		this.viewMoreClicked.emit();
	}
}
